import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CardList from './cardList';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridLg,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-start'
        },
        [theme.breakpoints.down('1500')]: {
            width: '90%',
        },
        [theme.breakpoints.down('1250')]: {
            width: '97%',
        },
    },
    icon: {
        width: '25px !important',
        marginLeft: 11,
        // fill: theme.palette.light.type2,
        fill: "#0B1742",
        height: 75,

    },
    logo: {
        width: 150,
        height: 40,
        fill: '#002C2E !important',
        opacity: 0.5,
        filter: ' grayscale(100%)',
    },
    'grid-logo': {
        paddingTop: 25,
        width: 300
    },
    copyRightText: {
        height: 45,
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& p': {
            marginBottom: "0px !important"
        },
        [theme.breakpoints.down('sm')]: {
    fontSize: 11
},
    }
}))

export default function Index() {

    const classes = useStyles()
    const state = [
        {
            title: 'راه‌های ارتباط با کارگزاری  پویان',
            list: [
                {
                    title: `تهران، خیابان شهیدبهشتی، تقاطع خیابان قنبرزاده  و خیابان خرمشهر ،پلاک 222 ،طبقه اول`,
                    icon: 'map'
                },
                // {
                //     title: 'مرکز تماس: 81021850-021',
                //     icon: 'tell'
                // },
                {
                    title: 'پشتیبانی: 91005777-021 , 53782000-021',
                    icon: 'tell'
                },
                // {
                //     title: 'info@pishrobroker.ir',
                //     icon: 'email'
                // },
            ]
        },
        {
            title: 'سامانه‌های کاربردی',
            list: [
                {
                    title: 'سامانه سجام',
                    icon: '',
                    link: 'https://www.sejam.ir/',
                },

                {
                    title: 'فیپیران ',
                    icon: '',
                    link: 'https://www.fipiran.com/',
                },
                {
                    title: 'سامانه مدیریت فناوری بورس تهران',
                    icon: '',
                    link: 'http://www.tsetmc.com',
                },
            ]
        },
        // {
        //     title: 'لینک‌های کاربردی',
        //     list: [
        //         {
        //             title: 'سامانه سجام',
        //             icon: '',
        //             link: 'https://dara.csdiran.com/sejam/bourse/fromcompany/7YK5R9hvRLl1Dnj9dpUKUzFKoDNiEi9dS3FnFExOtVgJCsm45GzVm3nG5nytnOm',
        //         },
        //         {
        //             title: 'سامانه سهام عدالت',
        //             icon: '',
        //             link: 'https://se-simabgoon.rayanbroker.ir/',
        //         },
        //         {
        //             title: 'دوره‌های آموزشی',
        //             icon: '',
        //             link: '',
        //         },
        //         {
        //             title: 'شماره حساب ها',
        //             icon: '',
        //             linkRouter: '/AcountNumber',
        //         },
        //     ]
        // },
    ]
    const icons = {
        header: 'logo-pishro',
        list: [
            'telegram',
            'instagram',
            'aparat',
            'twiter',

        ]
    }
    return (
        <>
            <div style={{ padding: '20px 0px', backgroundColor: "#F2F4F6" }}>
                <div className={classes.root}>
                    {
                        state.map((data, index) => {
                            return (
                                <CardList key={index} data={data} />
                            )
                        })
                    }
                    <div className={classes['grid-logo']}>
                        <div style={{ height: 37 }}>
                            <Link to="/">
                                {/* <svg className={classes.logo}>
                                    <use xlinkHref={`/sprit.svg#${icons.header}`}></use>
                                </svg> */}
                                {/* <h5>
                                    کارگزاری پویان
                                </h5> */}
                                <img height={40} src='/assets/images/logo.png' alt='' />
                            </Link>
                        </div>
                        <div>
                            {
                                icons.list.map((icon, index) => {
                                    return (
                                        <svg key={index} style={{ width: 25 }} className={classes.icon}>
                                            <use xlinkHref={`/sprit.svg#${icon}`}></use>
                                        </svg>

                                    )
                                })
                            }
                        </div>

                        <div>
                            <a
                                referrerpolicy="origin"
                                target="_blank"
                                href="https://trustseal.enamad.ir/?id=280030&amp;Code=o08KbJqZ135Q2ZR1VlYt"
                            >

                                <img
                                    referrerpolicy="origin"
                                    src="https://Trustseal.eNamad.ir/logo.aspx?id=280030&amp;Code=o08KbJqZ135Q2ZR1VlYt"
                                    alt=""
                                    style={{ cursor: 'pointer' }}
                                    id="o08KbJqZ135Q2ZR1VlYt"
                                />
                            </a>
                        </div>
                        {/* <div>
                            <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=244488&amp;Code=Xjg5aPL4TpQk7Tmovyi0"><img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=244488&amp;Code=Xjg5aPL4TpQk7Tmovyi0" alt="" style={{ cursor: "pointer" }} id="Xjg5aPL4TpQk7Tmovyi0" /></a>
                        </div> */}

                    </div>
                </div>
            </div>
            <div className={classes['copyRightText']}>
                <p style={{ marginBttotoom: "0px !important" }}>‏ © تمامی حقوق برای کارگزاری  پویان  محفوظ است 2023 Copyright</p>
            </div>
        </>
    )
}
